// extracted by mini-css-extract-plugin
export default {"namedLinksFooterSection":"NamedLinksFooterSection__namedLinksFooterSection--Ri","list":"NamedLinksFooterSection__list--1L","link":"NamedLinksFooterSection__link--3g"};